var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCashBlack = function SvgCashBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 4.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15ZM1 12a8.5 8.5 0 0 1 11-8.126 8.5 8.5 0 1 1 0 16.253A8.5 8.5 0 0 1 1 12Zm17 0c0-3.207-1.776-6-4.398-7.447a7.5 7.5 0 1 1 0 14.893A8.498 8.498 0 0 0 18 12ZM6 9.5h3V16h1V9.5h3v-1H6v1Z",
    fill: "#232837"
  })));
};

export default SvgCashBlack;